var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import "!style-loader!css-loader!react-toastify/dist/ReactToastify.css";
import React, { lazy, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import XcrollToTop from "react-scroll-to-top";
import { ToastContainer } from "react-toastify";
import { Footer } from "./components/common/Footer/Footer";
import { checkInfo } from "./components/common/function/checkInfo";
import { Header } from "./components/common/Header/Header";
import ScrollToTop from "./components/common/ScrollToTop/ScrollToTop";
import { ModalLoading } from "./components/Modal/ModalLoading/ModalLoading";
import { Pointing } from "./pages/Pointing";
var TestPage = lazy(function () {
    return import("./pages/TestPage").then(function (_a) {
        var TestPage = _a.TestPage;
        return ({ default: TestPage });
    });
});
var ModalError = lazy(function () {
    return import("./components/Modal/ModalError/ModalError").then(function (_a) {
        var ModalError = _a.ModalError;
        return ({ default: ModalError });
    });
});
function App() {
    useEffect(function () {
        checkInfo();
    }, []);
    return (_jsxs(Router, { children: [_jsx(XcrollToTop, { style: { background: "#f73f3f" }, smooth: true, color: "white" }, void 0), _jsx(ToastContainer, {}, void 0), _jsx(React.Suspense, __assign({ fallback: _jsx(_Fragment, {}, void 0) }, { children: _jsx(ModalError, {}, void 0) }), void 0), _jsx(Header, {}, void 0), _jsx(ScrollToTop, {}, void 0), _jsx(React.Suspense, __assign({ fallback: _jsx(_Fragment, {}, void 0) }, { children: _jsxs(Switch, { children: [_jsx(Route, { exact: true, path: "/test", component: TestPage }, void 0), _jsx(Route, { path: "/pointing", component: Pointing }, void 0)] }, void 0) }), void 0), _jsx(ModalLoading, {}, void 0), _jsx(Footer, {}, void 0)] }, void 0));
}
export default App;
function autho(arg0, autho) {
    throw new Error("Function not implemented.");
}
